/**
 * RA2N's size / radius / type scale, and the component sizing that goes with
 * it.
 *
 * A leaf module on purpose: it imports nothing. `AntdThemeProvider` reaches
 * `ThemeContext`, which reaches the theme configs, which reach
 * `customize/registry` — so a tenant importing these from the provider would
 * close that loop. Here there is nothing to loop through.
 *
 * Colour-free, so a nested `ConfigProvider` can restore the scale without also
 * pinning a palette.
 */

export const DESIGN_TOKEN = {
  borderRadius: 6,
  borderRadiusSM: 4,
  borderRadiusLG: 8,
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  fontSizeXL: 18,
  padding: 8,
  paddingXS: 4,
  paddingSM: 8,
  paddingMD: 12,
  paddingLG: 16,
  marginXS: 4,
  marginSM: 8,
  marginMD: 12,
  marginLG: 16,
  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
  boxShadowSecondary: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
  controlHeight: 40,
  controlHeightSM: 32,
  controlHeightLG: 48,
} as const;

export const DESIGN_COMPONENTS = {
  Button: {
    contentFontSize: 14,
    contentFontSizeLG: 16,
    contentFontSizeSM: 12,
    paddingBlock: 8,
    paddingInline: 16,
    paddingBlockSM: 4,
    paddingInlineSM: 8,
    paddingBlockLG: 12,
    paddingInlineLG: 24,
    borderRadius: 6,
    fontWeight: 500,
    onlyIconSize: 32,
  },
  Input: {
    paddingBlock: 8,
    paddingInline: 12,
    inputFontSize: 14,
  },
  Select: {
    optionFontSize: 14,
    optionHeight: 36,
  },
  Form: {
    labelFontSize: 14,
    verticalLabelPadding: '0 0 4px',
    itemMarginBottom: 16,
  },
  DatePicker: {
    fontSize: 14,
  },
} as const;
